import React from 'react';
import { connect } from 'react-redux';
import { subCollectionsNames } from 'utils/constants/graphs';
import Loader from 'features/Loader/Loader';
import Overview from './Overview';
import ProgressPhotos from './progress-photos/ProgressPhotos';
import ProgressGraphs from './progress-graphs/ProgressGraphs';
import './Progress.scss';

const Progress = ({
  clientId,
  workouts,
  graphsData,
  clientTrackObj,
  loadingCount,
  loadingClientTrack,
  loadingClientWorkouts
}) => {

  if (
    (loadingCount !== subCollectionsNames.length) ||
    loadingClientTrack ||
    loadingClientWorkouts
  ) {
    return(<Loader />);
  }

  return (
    <section className="progress-tab">
      <Overview
        clientId={clientId}
        workoutsCount={workouts?.length} />
      <ProgressPhotos clientId={clientId} />
      {
        !!Object.keys(graphsData).length &&
          <ProgressGraphs
            clientId={clientId}
            graphsData={graphsData}
            clientTrackObj={clientTrackObj || {}}
          />
      }
    </section>
  );
};

function mapStateToProps(state) {
  return {
    graphsData: state.progressReducer.graphsData,
    clientTrackObj: state.progressReducer.clientTrackObj,
    loadingCount: state.progressReducer.loadingCount,
    loadingClientTrack: state.progressReducer.loadingClientTrack,
    loadingClientWorkouts: state.workoutReducer.loading
  };
}

export default connect(mapStateToProps, null)(Progress);
